// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zG3L","badges":"styles_badges__2Pt-U"};